import { getCurrentInstance } from 'vue'
import ClientResource from '@/modules/clients/common/services/ClientResource';

const clientResource = new ClientResource();

export default {
  methods: {
    superUser() {
      return this.$store.getters.getUserInfo('super_user');
    },

    disableExecutiveRole(role) {
      if(this.superUser()) { return false; }
      if(role.slug == 'executive') { return true; }
      return false;
    },

    checkPermission(section, slug) {
      let permissions = this.$store.getters.getUserInfo('all_permissions')
      if(!permissions) { return false }
      return permissions.find((perm) => {
        return perm.section == section && perm.slug == slug
      })
    },

    getAllowedProcessors() {
      return this.$store.getters.getUserInfo('allowed_processors')
    },

    getAllProcessors() {
      return this.$store.getters.getUserInfo('all_processors')
    },

    getProcessorSlug(processor_id = 1) {
      const processors = this.$store.getters.getUserInfo('all_processors');
      if(!processors) { return 'elavon'; }
      const processor = processors.find((processor) => processor.processor_id == processor_id);
      return processor ? processor.slug : 'elavon';
    },

    getProcessorName(processor_id = 1) {
      const processors = this.$store.getters.getUserInfo('all_processors');
      if(!processors) { return 'Elavon'; }
      const processor = processors.find((processor) => processor.processor_id == processor_id);
      return processor ? processor.name : 'Elavon';
    },

    getProcessorNameWithSlug(slug) {
      const processors = this.$store.getters.getUserInfo('all_processors');
      if(!processors) { return 'Elavon'; }
      const processor = processors.find((processor) => processor.slug == slug);
      return processor ? processor.name : 'Elavon';
    },

    getProcessorWithSlug(slug) {
      const processors = this.$store.getters.getUserInfo('all_processors');
      if(!processors) { return null }
      const processor = processors.find((processor) => processor.slug == slug);
      return processor ? processor : null
    },

    getProcessorIdWithSlug(slug) {
      const processors = this.$store.getters.getUserInfo('all_processors');
      if(!processors) { return null }
      const processor = processors.find((processor) => processor.slug == slug);
      return processor ? processor.processor_id : null
    },

    mimeToExtension(fileData) {
      var mimeToExtension = {
        "image/jpeg": "jpeg",
        "image/png": "png",
        "application/pdf": "pdf",
        "text/csv": "csv",
        "audio/mpeg": "mp3"
      }
      var extension = mimeToExtension[fileData.type];
      if (!extension) { return false; }
      return "." + extension;
    },

    isNumber(keypress) {
      keypress = (keypress) ? keypress : window.event;
      var charCode = (keypress.which) ? keypress.which : keypress.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45) {
        keypress.preventDefault();
      } else {
        return true;
      }
    },

    generateSlug(name) {
      if (!name) return;
      return name
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, '')
        .trim()
        .replace(/\s+/g, '_');
    },

    statusId(status_slug, option_slug) {
      if(!status_slug && !option_slug) { return null; }
      let permitted_status = this.$store.getters.getUserInfo('permitted_client_status')
      if(!permitted_status) { return null; }
      let status = permitted_status.find((status) => {
        return status.slug == status_slug
      })
      if(!status) { return null; }
      if(!option_slug) { return status.client_status_id; }
      let option = status.client_status_options.find((option) => {
        return option.slug == option_slug
      })
      if(!option) { return null; }
      return option.client_status_option_id;
    },

    showFile(fileData) {
      var fileURL = window.URL.createObjectURL(fileData);
      let tab = window.open();
      tab.location.href = fileURL;
    },

    downloadFile(fileData, fileName) {
      const blob = new Blob([fileData]);
      var extension = this.mimeToExtension(fileData);
      if(!extension) { alert('Invalid File Extension.'); return false; }
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName + extension;
      link.click();
    },

    clearSearch() {
      this.$router.push({ query: { page: 1 } })
    },

    hitSearch() {
      var q = this.$route.query.q;
      var existing = null
      if(existing) {
        existing = JSON.parse(atob(q));
      }
      this.filters = { ...this.filters, ...existing};
      var encrypt = btoa(JSON.stringify(this.filters));
      this.$router.push({ query: { page: 1, q: encrypt } })
    },

    getOrderType(order) {
      if(!order) { return '-' }
      if(order.order_type == 'first') { return 'Application Order' }
      else if(order.order_type == 'taliup_register') { return 'Taliup Register' }
      else if(order.order_type == 'add_equipment' && order.commission == 1) { return 'AE Sales' }
      else if(order.order_type == 'add_equipment' && order.commission == 0) { return 'AE Service' }
      else { return '-' }
    },

    formatPhoneNumber(phoneNumber) {
      const cleaned = ("" + phoneNumber).replace(/^\\+?1?(\d{10})$/, "$1");
      const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return "(" + match[1] + ")-" + match[2] + " " + match[3];
      }
      return phoneNumber;
    },

    secondsToMinutes(seconds) {
      return Math.round(seconds / 60);
    },

    getActiveTab(tab) {
      return this.$route.meta.tab === tab ? 'primary' : 'light'
    },

    openClientInNewTab(clientId) {
      const url = `/client/${clientId}`;
      window.open(url, '_blank');
    },

    openClientPopup(clientId) {
      this.$store.commit('OPEN_CLIENT_POPUP', clientId);
    },

    closeClientPopup() {
      this.$store.commit('CLOSE_CLIENT_POPUP');
    },

    async showAttachment(attachment, client_id, view) {
      var api = await clientResource.showClientAttachment(client_id, attachment.client_attachment_id)
      var temp_link = await api.data.data.temp_link
      if(temp_link) {
        window.open(temp_link, '_blank');
      } else {
        alert('Error fetching attachment');
      }
    },

    clearFilters() {
      this.$router.push({ query: { page: 1 } })
    },
  }
}